import PropTypes from 'prop-types';

import FeedFloToolTip from '../../atoms/FeedFloToolTip/FeedFloToolTip';
import { getTransportStatuses, resolveTransportBadge, TRANSPORT_LABELS } from '../../utils/transportStatus';

import './TransportStatusBadges.scss';

function TransportStatusBadges({ user = null, transports = null, variant = 'default', className = '' }) {
  const resolvedTransports = transports || getTransportStatuses(user);

  // NOTE: This sort should match the TransportMethodSelecto.jsx's TRANSPORT_OPTIONS order
  return (
    <div className={`TransportStatusBadges TransportStatusBadges--${variant} ${className}`.trim()}>
      {resolvedTransports.sort((a, b) => a.type < b.type).map((transport) => {
        const { variant: badgeVariant, icon, tooltip } = resolveTransportBadge(transport);

        return (
          <FeedFloToolTip key={transport.type} description={tooltip} position="top" multiline={true}>
            <span className={`TransportStatusBadges-badge TransportStatusBadges-badge--${badgeVariant}`}>
              <span className="TransportStatusBadges-status">{icon}</span>
              <span className="TransportStatusBadges-label">{TRANSPORT_LABELS[transport.type]}</span>
            </span>
          </FeedFloToolTip>
        );
      })}
    </div>
  );
}

TransportStatusBadges.propTypes = {
  user: PropTypes.object,
  transports: PropTypes.array,
  variant: PropTypes.oneOf(['default', 'compact']),
  className: PropTypes.string,
};

export default TransportStatusBadges;
